






































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Company} from '@/interfaces/company.interface';
import {VALIDATION_RULES} from '@/helpers/helpers';
import {namespace} from 'vuex-class';

const companiesModule = namespace('companies');

@Component
export default class CompanyEdit extends Vue {
  @Prop({default: {}}) company!: Company;

  requiredRule = [...VALIDATION_RULES.required];

  valid = false;

  get companyTypes() {
    return [
      {name: 'consignee', label: 'Consignee'},
      {name: 'shipper', label: 'Shipper'}
    ];
  }

  handleSubmit() {
    this.valid && this.$store.dispatch('companies/UPDATE_COMPANY', {
      company: this.company
    });
    // TODO: Close after edit
  }
}
